import React, { Component} from 'react';
import { transferHundredPoint } from '../../utils/Shared/methods';
import './index.scss';
import arrowUp from '../../../images/arrowUp.png'
import arrowDown from '../../../images/arrowDown.png'
import pic from '../../../images/pin.svg';
import editPic from '../../../images/edit.svg'
import editPink from '../../../images/edit_pink.svg'
import ReactTooltip from 'react-tooltip';
class ShelterChartTable extends Component {	
	constructor(params) {
		super(params);
		this.state = {
			csvData: [],			
			ascendingSort: {
				0:{
					0: true,
					1: true,
					2: true,
					3: true,
					4: true,
					5: true,
					6: true,
					7: true,
					8: true,
					9: true,
					10: true,
				},
				1:{
					0: true,
					1: true,
					2: true,
					3: true,
					4: true,
					5: true,
					6: true,
					7: true,
					8: true,
					9: true,
					10: true,
				},
				2:{
					0: true,
					1: true,
					2: true,
					3: true,
					4: true,
					5: true,
					6: true,
					7: true,
					8: true,
					9: true,
					10: true,
				},
				3:{
					0: true,
					1: true,
					2: true,
					3: true,
					4: true,
					5: true,
					6: true,
					7: true,
					8: true,
					9: true,
					10: true,
				},
				4:{
					0: true,
					1: true,
					2: true,
					3: true,
					4: true,
					5: true,
					6: true,
					7: true,
					8: true,
					9: true,
					10: true,
				},
				5:{
					0: true,
					1: true,
					2: true,
					3: true,
					4: true,
					5: true,
					6: true,
					7: true,
					8: true,
					9: true,
					10: true,
				},
				6:{
					0: true,
					1: true,
					2: true,
					3: true,
					4: true,
					5: true,
					6: true,
					7: true,
					8: true,
					9: true,
					10: true,
					11:true
				},
				7:{
					0: true,
					1: true,
					2: true,
					3: true,
					4: true,
					5: true,
					6: true,
					7: true,
					8: true,
					9: true,
					10: true,
					11:true
				},
				8:{
					0: true,
					1: true,
					2: true,
					3: true,
					4: true,
					5: true,
					6: true,
					7: true,
					8: true,
					9: true,
					10: true,
					11:true
				},
				9:{
					0: true,
					1: true,
					2: true,
					3: true,
					4: true,
					5: true,
					6: true,
					7: true,
					8: true,
					9: true,
					10: true,
					11:true
				},
			}
		};
	}
	componentDidUpdate(prevProps, prevState) {
		if (prevProps !== this.props) {			
			this.handleLoadCsvData();
			this.setState({activeIndex:this.props.activeIndex},()=>{
				const element = document.getElementsByClassName('active');
				if(element.length>0) {
					// 只滾動表格內容，不滾動整個頁面
					const tableContainer = element[0].closest('.table');
					if(tableContainer) {
						// 將選中的行滾動到表格容器的頂部
						const rowTop = element[0].offsetTop;
						const headerHeight = element[0].closest('table').querySelector('tr').offsetHeight;
						tableContainer.scrollTop = rowTop - headerHeight;
					}
				}
			})
		}
	}
	componentDidMount() {		
		this.handleLoadCsvData();		
	}
	handleLoadCsvData() {
		if (this.props.csvData) {
			const { csvData } = this.props
			const villageHighlightNames = this.props.villageHighlightNames || [];
			const normalize = s => (s == null ? '' : s.toString().trim().replace(/^["']|["']$/g, '').trim());
			const highlightSet = new Set(villageHighlightNames.map(normalize));

			csvData.forEach((data) => {
				if (data) {
					data.table = data.csv.split('\r\n').map((row) => {
						return row.split(',');
					})
					data.table = data.table.filter(row => row.length > 1)

					// 點地圖區塊後，把名稱符合的列排到 header 後面（不動 data.csv，下載不受影響）
					if (highlightSet.size > 0 && data.table.length > 1) {
						const header = data.table[0];
						const matching = [];
						const nonMatching = [];
						for (let i = 1; i < data.table.length; i++) {
							const name = normalize(data.table[i][0]);
							if (highlightSet.has(name)) matching.push(data.table[i]);
							else nonMatching.push(data.table[i]);
						}
						data.table = [header, ...matching, ...nonMatching];
					}
				}
			})
			this.setState({ csvData })
		}
		else {
			this.setState({
				csvData: [],
			})
		}
	}

	sortCsvData = (indicator, column) =>{		
		let colHeader = ['災民收容所名稱','收容所地址','管理層級', '服務里別', '室內<br>可收容人數', '室外<br>可收容人數', '室外容納面積<br>(平方公尺)','室內容納面積<br>(平方公尺)', '適用災別', '適合避難弱者安置', '設施設備情形','聯絡人姓名', '聯絡人電話', '收容所管理單位','管理人姓名','管理人電話','收容所縣市','收容所鄉鎮','收容所村里','災民收容所編號','經度','緯度'];
		const { csvData, ascendingSort } = this.state				
		ascendingSort[indicator][column] = !ascendingSort[indicator][column]
		if(ascendingSort[indicator][column]){//升冪
			if(column === 0){
				csvData[indicator] && csvData[indicator].table.sort((a,b) =>{					
					if(colHeader.includes(a[column])){
						return -1
					}else if(colHeader.includes(b[column])){
						return 1
					}
					if(a[column] && b[column]){
						return -a[column].localeCompare(b[column], "zh-Hant")
					}
					return 0
				})
			}else{
				csvData[indicator] && csvData[indicator].table.sort((a, b) =>{
					if(colHeader.includes(a[column])){
						return -1
					}else if(colHeader.includes(b[column])){
						return 1
					}
					if(Number(isNaN(a[column])) || isNaN(b[column])){
						return -a[column].localeCompare(b[column], "zh-Hant")
					}
					return Number(a[column])-Number(b[column])
				})
			}
		}else{//降冪
			if(column === 0){
				csvData[indicator] && csvData[indicator].table.sort((a,b) =>{
					if(colHeader.includes(a[column])){
						return -1
					}else if(colHeader.includes(b[column])){
						return 1
					}
					if(a[column] && b[column]){
						return a[column].localeCompare(b[column], "zh-Hant")
					}
					return 0
				})
			}else{
				csvData[indicator] && csvData[indicator].table.sort((a, b) =>{
					if(colHeader.includes(a[column])){
						return -1
					}else if(colHeader.includes(b[column])){
						return 1
					}
					if(Number(isNaN(a[column])) || isNaN(b[column])){
						return a[column].localeCompare(b[column], "zh-Hant")
					}
					return Number(b[column])-Number(a[column])
				})
			}
		}

		
		this.setState({csvData, ascendingSort, activeIndex:0});		
	}

	scrollToSection = (sectionId)=>{
		const element = document.getElementById(sectionId);
		if(element) {
			element.scrollIntoView({behavior: "smooth"})
		}
	}
	
	handlePinClick = (index,shelter_id)=>{
		this.setState({activeIndex:index});
		if(this.props.onClick){
			this.props.onClick(shelter_id);
		}
		// 移除滾動到地圖的行為
		// this.scrollToSection('anchor');
	}
	handleEditClick = (shtler_id)=>{		
		if(this.props.onEdit){
			this.props.onEdit(shtler_id);
		}
	}
	handleSingleEditShelter = ()=>{
		this.props.handleSingleEditShelter();
	}

	render() {
		const { csvData, ascendingSort, activeIndex } = this.state
		const{isAuthMemberLogin} = this.props
		const{isEditMode} = this.props
		const { activeShelterId } = this.props;
		const villageHighlightCount = this.props.villageHighlightCount || 0;
		const breakIndex = [0,8];	
		return (
			<React.Fragment>
				{
					csvData &&
					csvData.map((indicator, indicatorIndex) => {		
						var shelter_id_index = indicator.table[0].indexOf('災民收容所編號');
						var shelter_name_index = indicator.table[0].indexOf('災民收容所名稱');						
						return (
							indicator &&
							<React.Fragment key={indicatorIndex}>
								{/* <p className="evacuation-datatitle">{ indicator.title }</p> */}
								<table className="evacuation-datatable shelter-table">
									<tbody>
										{
											indicator &&
											indicator.table.map((tableRow, tableRowIndex) => {
												if(tableRowIndex === 0){
													return <React.Fragment key={tableRowIndex}>
														<tr style={{position:'sticky', top:0, zIndex:1, borderTop : 0 , backgroundColor:'#fff'}}>
															<td>
																位置
																{/* <input type='button' className='evacuation-datatable-td-btn-edit' value='單筆修改申請' onClick={() => this.handleSingleEditShelter()} data-tip="test" ></input> */}

																<a href="javascript:void(0)" data-tip="單筆修改申請">
																	<img className='evacuation-datatable-editbut' src={editPink} onClick={() => this.handleSingleEditShelter()} data-tip="單筆修改申請"></img>
																</a>
																</td>
															{
																tableRow.length > 1 &&
																tableRow.map((tableData, tableDataIndex) => {
																	const formattedData = tableData.replace(/"/g, '').trim();
																	const dataWithBreaks = formattedData.split('<br>').map((item, index) => (
																		<React.Fragment key={index}>
																			{item}
																			{index < formattedData.split('<br>').length - 1 && <br />}
																		</React.Fragment>
																	));

																	// 檢查該欄位的第一筆數據是否為數值
																	const firstDataRow = indicator.table[1];
																	const isNumericColumn = firstDataRow && isFinite(firstDataRow[tableDataIndex]) && firstDataRow[tableDataIndex] !== '' && tableDataIndex !== 0;

																	return (
																		<td key={tableDataIndex} className={isNumericColumn ? 'evacuation-datatable-td-right' : ''} style={{ cursor: "pointer" }} onClick={() => this.sortCsvData(indicatorIndex, tableDataIndex)}>
																		<div>
																			{dataWithBreaks}
																			{
																				!ascendingSort[indicatorIndex][tableDataIndex] &&
																				<img className="arrow" src={arrowDown} alt="" />
																			}
																			{
																				ascendingSort[indicatorIndex][tableDataIndex] &&
																				<img className="arrow" src={arrowUp} alt="" />
																			}
																			</div>
																		</td>
																	)
																})
															}
														</tr>
													</React.Fragment>
												}
												return (
													<React.Fragment key={tableRowIndex}>
														<tr className={((activeShelterId != null ? tableRow[shelter_id_index] != null && tableRow[shelter_id_index].toString().trim() === activeShelterId.toString().trim() : activeIndex === tableRowIndex) || (villageHighlightCount > 0 && tableRowIndex >= 1 && tableRowIndex <= villageHighlightCount)) ? 'active' : ''}>
														<td>
															<a href='javascript:void(0)'> <img className='evacuation-datatable-td-pin' src={pic} onClick={(e)=> this.handlePinClick(tableRowIndex,tableRow[shelter_id_index].toString().trim())}/></a>
															{isEditMode && <a href='javascript:void(0)'> <img className='evacuation-datatable-td-pin' src={editPic} onClick={(e)=>{this.handleEditClick(tableRow[shelter_id_index].toString().trim())}}></img> </a>}															
														</td>
															{
															tableRow.length > 1 &&
															tableRow.map((tableData, tableDataIndex) => {
																
																return (
																	<React.Fragment key={tableDataIndex}>
																		{
																			((!isFinite(tableData) || tableData==='') || tableDataIndex === 0 || tableRowIndex === 0) 																			
																			?<td>{ tableData }</td>
																			:<td className='evacuation-datatable-td-right'>{ transferHundredPoint(tableData) }</td>
																		}
																	</React.Fragment>
																)
															})
														}
														</tr>
													</React.Fragment>
												)
											})
										}
									</tbody>
								</table>
							</React.Fragment>
						)
					})
				}
			</React.Fragment>
		);
	}
}

export default ShelterChartTable;
